import * as React from "react";
import { 
    ApplicationState, 
    UserStatus
} from "../user/UserStore";
import {connect} from "react-redux";
import { ErrorModal } from "../util/ErrorModal";
import { RequestDenied } from "../http/protocol";

const mapStateToProps = (state : ApplicationState) : ApplicationState => {
    return state;
};

export class RequestDeniedModal extends React.Component<ApplicationState,{}> {
   
    constructor(props:ApplicationState){
        super(props);
    }

    requiredWriteAccessMessage(requestDenied:RequestDenied){
        //if requiresWriteAccess is false so is required
        if(requestDenied.permittedCategories!.requiresWriteAccess===false){
            return "";
        }else{
            return " (with Write enabled)";
        }
    }

    getMessage(requestDenied: RequestDenied) : string {
        return requestDenied.description
                +"\nGrant permission "+requestDenied.permittedCategories!.categoryTypes
                +this.requiredWriteAccessMessage(requestDenied)
                +(requestDenied && requestDenied.userGroupIds && requestDenied.userGroupIds.length===1?
                    ` to user group ${requestDenied.userGroupIds}`:
                    ` to at least one user group: [${requestDenied.userGroupIds}]`);
                
    }
    
    closeModal(){
        let applicationState:ApplicationState = this.props;
        applicationState.user.displayRequestForbidden = false;
        this.setState({});
    }

    displayError(show?:boolean){
        let message = this.getMessage(this.props.user.requestDenied!);
        console.log(message)
        if(localStorage.getItem("showRequestDeniedModal") == "true"){
            return (<ErrorModal
                show={show}
                heading={"Request Denied"}
                description={message}
                okLabel="OK"
                onOk={this.closeModal.bind(this)}
                onCancel={this.closeModal.bind(this)}
                disableActions={true}
                />
            );
        } else {
            return <></>
        }
    }

    
    render(){
        if(this.props.user.status !== UserStatus.LOGGED_IN || this.props.user.requestDenied===undefined) {
            return <div/>;
        }
        return this.displayError(this.props.user.displayRequestForbidden===true? true: false);
    }
}

export default connect(mapStateToProps)(RequestDeniedModal);